import airAirHeatpump from './air-air-heatpump.png'
import basementCeiling from './basement-ceiling.png'
import basementWall from './basement-wall.png'
import blowInInsulation from './blow-in-insulation.png'
import districtHeating from './district-heating.png'
import door from './door.png'
import floorPlate from './floor-plate.png'
import groundSourceHeatPump from './ground-source-heatpump.png'
import heatpump from './heatpump.png'
import pelletHeating from './pellet-heating.png'
import roofInsulation from './roof-insulation.png'
import roofWindow from './roof-window.png'
import upperFloor from './upper-floor.png'
import ventilation from './ventilation.png'
import walls from './walls.png'
import window from './window.png'

export const housePartsIcons = {
  airAirHeatpump,
  basementCeiling,
  basementWall,
  blowInInsulation,
  groundSourceHeatPump,
  districtHeating,
  door,
  floorPlate,
  heatpump,
  pelletHeating,
  roofInsulation,
  roofWindow,
  upperFloor,
  ventilation,
  walls,
  window,
} as const

export type HousePartIconKey = keyof typeof housePartsIcons
